export default __webpack_public_path__ + "static/media/pifinancial.9dd93ae5.jpg";